import { Datastore } from "util/datastore";
import type { Comment } from "component/comment";
import { CommentConfig } from "component/comment";
import { Feature } from "util/stdtypes";

export const RecordEntryUrlFeature : Feature<CommentConfig, {}> = {
    name: 'Record Entry URL',
    key: 'record_entry_url',
    dev: true,
    providesConfig: {
        commentPostCheckers: [recordEntryPointCheckerAsync],
    }
}

export async function recordEntryPointCheckerAsync(datastore : Datastore, comment : Comment) {
    const {entryUrl} = datastore.getGlobalParams();
    if (entryUrl) {
        return {allow: true, commentProps: {entryUrl}};
    } else {
        return {allow: true}
    }
}



